
import { defineComponent } from 'vue'
import { useMessengerStore } from '@/store/stores/messenger'
import { hasGcb2ChatViewAccess } from '@/helpers/gcb2/chatAccess'
import { trackMultichatOpen } from '@/helpers/gcb2/multichatAnalytics'
import cfg from '../../config'

export default defineComponent({
    data() {
        return {
            mainLogo: require('@/assets/Logo_Chat.svg'),
        }
    },
    computed: {
        project(): any {
            const projectId = this.$route?.params?.id
            return this.$store.getters.projectById(projectId)
        },
        canViewChat(this: { project? }) {
            return hasGcb2ChatViewAccess(this.project)
        },
        unreadCount(this: { project?; canViewChat? }) {
            if (!this.project?.id || !this.canViewChat) {
                return 0
            }
            const messengerStore = useMessengerStore()
            return messengerStore.projectId === this.project.id
                ? messengerStore.projectUnreadCount
                : 0
        },
        unreadLabel(this: { unreadCount: number }) {
            return this.unreadCount >= 99 ? '99+' : String(this.unreadCount)
        },
        showCounterForBranch(this: { unreadCount: number }) {
            return this.unreadCount > 0
        },
        chatRout(this: { project? }) {
            return `/project/${this.project?.id}/GCB2?section=chat&fs=1`
        },
    },
    methods: {
        trackOpen() {
            trackMultichatOpen('topbar')
        },
    },
    watch: {
        'project.id': {
            immediate: true,
            handler(projectId: string) {
                if (!projectId || !this.canViewChat) {
                    return
                }
                const messengerStore = useMessengerStore()
                messengerStore.setProjectId(projectId)
                messengerStore.setOmnichannel(true)
                messengerStore.fetchProjectUnreadCount()
            },
        },
    },
})
